// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Dominica from '../_raw/flag/icon_flag_dominica.png';

export default () => <img src={Dominica} alt="Dominica" />;
